<template>
  <div class="tj-paging-overlay d-flex align-center justify-space-between">
    <v-btn icon small outlined @click="onPrevClick" title="Anterior" ripple>
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>

    <v-btn icon small outlined @click="onNextClick" title="Próxima" ripple>
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from "vue"
export default Vue.component("tj-paging-overlay", {
  methods: {
    onPrevClick(){
      this.$emit("prev")
    },

    onNextClick(){
      this.$emit("next")
    }
  }
})
</script>

<style>
  .tj-paging-overlay {
    position: sticky;
    bottom: 100px
  }

  .tj-paging-overlay button:not(.theme--dark) {
    background-color: #eee;
  }

</style>